<template>
  <div class="permission-page">
    <div class="page-heading">
      <div>
        <h2>{{ $t('HT.menu.product.permission') }}</h2>
        <p>{{ $t('HT.subordinate.permission.description') }}</p>
      </div>
    </div>
    <div class="content-card">
      <permission-list
        :accounts="accounts"
        :total="permissionTotal"
        @configure="openConfig"
        @query="getPermissionList"
      ></permission-list>
    </div>
  </div>
</template>

<script lang="jsx">
import PermissionList from './components/permissionList.vue';
import PermissionConfigModal from './components/permissionConfigModal.vue';

export default {
  name: 'SubordinatePermission',
  components: { PermissionList },
  data() {
    return {
      // 产品权限分配账号列表
      accounts: [],
      // 产品权限分配列表总数
      permissionTotal: 0,
      // 权限配置可选产品，页面内只请求一次并复用
      permissionProducts: [],
      // 产品 ID 对应的产品名称
      permissionProductMap: {},
      // 当前产品权限列表查询条件
      permissionFilter: {
        accountname: '',
        page: 1,
        size: 10
      }
    };
  },
  created() {
    this.getPermissionProducts();
    this.getPermissionList({ page: 1, size: 10 });
  },
  methods: {
    // 获取权限配置产品并建立产品 ID 与名称映射
    getPermissionProducts() {
      this.$api.product.getPermissionProductList().then((res) => {
        if (res.code == 10000) {
          this.permissionProducts = res.data || [];
          this.permissionProductMap = this.permissionProducts.reduce((result, product) => {
            result[String(product.id)] = product.name;
            return result;
          }, {});
          // 产品接口后返回时，重新转换当前页的授权产品名称
          this.accounts = this.accounts.map(this.formatPermission);
        }
      });
    },
    // 获取产品权限分配分页列表
    getPermissionList(params) {
      this.permissionFilter = { ...this.permissionFilter, ...params };
      this.$uxLoading.show();
      this.$api.product.getPermissionList(this.permissionFilter).then((res) => {
        if (res.code == 10000) {
          this.accounts = (res.data || []).map(this.formatPermission);
          this.permissionTotal = res.total_size || 0;
        }
      });
    },
    // 将接口字段转换为权限列表展示字段
    formatPermission(item) {
      const productIds = item.authorized_product_list || [];
      const productNames = productIds.map(
        (productId) =>
          this.permissionProductMap[String(productId)] ||
          this.$t('HT.subordinate.permission.productId', { id: productId })
      );
      return {
        ...item,
        id: item.account_id,
        name: item.username,
        level: item.supervisor
          ? this.$t('HT.userInfo.super')
          : item.owner
            ? this.$t('HT.personal.text4')
            : this.$t('HT.personal.text5'),
        enabled: item.disabled,
        productIds: productIds.slice(),
        productNames: productNames.slice(),
        productCount: item.authorized_products || String(productIds.length),
        lastUpdated: item.updated_time || ''
      };
    },
    // 打开当前客户的接口权限配置弹窗
    openConfig(account) {
      this.$uxModal.show({
        title: this.$t('HT.subordinate.permission.configTitle', { account: account.name }),
        width: '600px',
        content: (h) =>
          h(PermissionConfigModal, {
            props: {
              account,
              products: this.permissionProducts
            }
          }),
        confirm: (data) => this.saveConfig(account, data)
      });
    },
    // 保存权限配置并覆盖账号已有产品权限
    saveConfig(account, data) {
      const productIds = Array.isArray(data && data.selectedIds) ? data.selectedIds : [];
      if (!productIds.length) {
        this.$confirm(
          this.$t('HT.subordinate.permission.emptyConfirmMessage'),
          this.$t('HT.subordinate.common.tip'),
          {
            type: 'warning',
            confirmButtonText: this.$t('HT.subordinate.permission.confirmSave'),
            cancelButtonText: this.$t('HT.subordinate.permission.backToEdit')
          }
        ).then(() => {
          this.setPermission(account, productIds);
        });
        return;
      }
      this.setPermission(account, productIds);
    },
    // 提交账号产品授权并刷新当前分页列表
    setPermission(account, productIds) {
      this.$uxLoading.show();
      this.$api.product
        .setPermission({
          account_id: account.account_id,
          product_ids: productIds
        })
        .then((res) => {
          if (res.code == 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.subordinate.permission.saveSuccess'));
            this.getPermissionList(this.permissionFilter);
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.permission-page {
  min-width: 1080px;
  padding: 24px;
  color: #1f2937;
}
.page-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  h2 { margin: 0 0 8px; font-size: 22px; font-weight: 600; }
  p { margin: 0; color: #8a94a6; font-size: 13px; }
}
.content-card { background: #fff; border: 1px solid #edf0f5; border-radius: 6px; box-shadow: 0 2px 8px rgba(35, 50, 80, 0.04); }
@media screen and (max-width: 1280px) {
  .permission-page { padding: 18px; }
}
</style>
